import LaravelRouter from "../thirdparty/Ziggy/route";
import {getBackToAll, laravelRoute, objToUrl, setBackToAll, slugify, ucfirst} from "./common";
import moment from 'moment'

const roles = {
    // admin: 1, //removed, all admin users migrated to sales
    dealer: 2,
    sales: 3,
    super_admin: 4,
};
const userIsRole = function (role) {
    if (roles[role] && window.loggedInUser
        && window.loggedInUser.role_id === roles[role]) {
        return true;
    }
    return false;
}
const userHasPrivilege = function (privilege) {
    if (window.loggedInUser
        && window.loggedInUser.privileges
        && window.loggedInUser.privileges[privilege]) {
        return true;
    }
    return false;
}
const userIsAdmin = function () {
    return userIsRole('sales') || userIsRole('super_admin')
};
const MyPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$laravelRoute = laravelRoute;
        Vue.prototype.slugify = slugify;
        Vue.prototype.$ucfirst = ucfirst;
        Vue.prototype.TINYMCE_API_KEY = process.env.MIX_TINYMCE_API_KEY;
        Vue.prototype.site_settings = window.site_settings;
        Vue.prototype.loggedInUser = window.loggedInUser;
        Vue.prototype.userPricingRules = window.user_pricing_rules;
        Vue.prototype.defaultPricing = window.defaultPricing;
        Vue.prototype.getSiteSetting = function(name){
            console.log(window.site_settings[name])
            if (window.site_settings && window.site_settings[name].enabled) {
                return window.site_settings[name].value
            }
            return null;
        }
        Vue.prototype.$canEditCompany = function (company_id) {
            return userIsRole('super_admin') || userIsRole('sales') ||
                (window.loggedInUser.company_id === parseInt(company_id)
                    && userHasPrivilege('can_edit_company')
                )
        };
        Vue.prototype.$canManageCompany = function (company_id) {
            return userIsRole('super_admin') || userIsRole('sales') ||
                (window.loggedInUser.company_id === parseInt(company_id)
                    && (userHasPrivilege('is_company_manager') || userHasPrivilege('can_edit_company'))
                )
        };
        Vue.prototype.$laravelRouter = function (name, args = [], abs = true) {
            let route = null;
            try{
                route =  LaravelRouter(name, args, abs);
            } catch(e) {
                console.warn(e);
            }
            return route;
        };
        Vue.prototype.dateToMoment = function (d, format = 'DD/MM/YYYY h:mma') {
            let date = false;
            if (d && typeof d === 'string') {
                date = moment(d);
            } else if (d && typeof d === 'object' && d.date){
                date = moment(d.date);
            }
            if (date && format) {
                return date.format(format);
            }
            return date;
        };
        Vue.prototype.userHasPrivilege = userHasPrivilege
        Vue.prototype.backToAll = function (privilege) {
            const url = getBackToAll();
            if (url) {
                this.$router.push(url)
            } else {
                this.$router.go(-1)
            }
        };
        Vue.prototype.$userRoleId = function (rolename) {
            if (roles[rolename]) {
                return roles[rolename]
            }
            return false;
        };
        Vue.prototype.$userIsAdmin = userIsAdmin;
        Vue.prototype.$userIsSuperAdmin = function () {
            return userIsRole('super_admin')
        };
        Vue.prototype.$userIsDealer = function () {
            return userIsRole('dealer')
        };
        Vue.prototype.$userCan = perm => {
            return window.user_permissions && window.user_permissions[perm]
        };
        Vue.prototype.$userIsRole = userIsRole;
        Vue.prototype.$docTitle = {
            get: () => document.title,
            set: (v) => { document.title = v }
        };
        Vue.prototype.$updateUrlQuery = function(query, backToAll = true){
            let new_query = JSON.parse(JSON.stringify(this.$route.query));
            for (let key in query) {
                if (query[key] === null) {
                    if (new_query.hasOwnProperty(key)) {
                        delete new_query[key]
                    }
                } else {
                    new_query[key] = query[key]
                }
            }
            let query_url = objToUrl(new_query)
            if (new_query !== query_url) {
                this.$router.replace({ query: new_query })
            }
            if (backToAll) {
                setBackToAll(window.location.pathname + window.location.search);
            }
        };
        Vue.prototype.$unFocusElement = function (selector) {
            document
                .querySelectorAll(selector)
                .forEach((el) => {
                    el.blur()
                })
        }
        Vue.prototype.$createHash = function (str) {
            str += ''
            return str.split('').reduce((prevHash, currVal) =>
                (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
        }
        Vue.prototype.$canChangeBid = function (bid, vehicle) {
            if (userIsAdmin()) {
                return true
            } else if (bid.user_id !== this.loggedInUser.id) {
                return false
            }

            let auction_datetime = vehicle.auction_date

            const aucTime = window.moment.tz(auction_datetime, 'Asia/Tokyo');
            const now = window.moment.tz(window.moment(), 'Asia/Tokyo');
            //if no start time then allow change bid at any time
            if ('00:00' === aucTime.format('HH:mm')) {
                return true
            }
            if (aucTime.diff(now, 'minutes') > 30) {
                return true
            }
            return false;
        }

    }
};
export default MyPlugin;



// WEBPACK FOOTER //
// ./resources/js/util/vue_plugin.js